export const lazyResetTeamsClientDataLayer = async (): Promise<void> => {
  const module = await import(
    /* webpackChunkName: "4-feat-reset-clientdatalayer" */ '@ms/yammer-web-support/dist/teams/cdl/initializeClientDataLayer'
  );

  module.resetClientDataLayer();
};
